import {
  GET_HIGHLIGHTS_DETAILS_SUCCESS,
  GET_HIGHLIGHTS_DETAILS_ERROR,
  CLEAR_GET_HIGHLIGHTS_DETAILS,
  ADD_HIGHLIGHTS_DETAIL_SUCCESS,
  ADD_HIGHLIGHTS_DETAIL_ERROR,
  CLEAR_ADD_HIGHLIGHTS_DETAIL,
  PATCH_HIGHLIGHTS_DETAIL_SUCCESS,
  PATCH_HIGHLIGHTS_DETAIL_ERROR,
  CLEAR_PATCH_HIGHLIGHTS_DETAIL,
  DELETE_HIGHLIGHTS_DETAIL_SUCCESS,
  DELETE_HIGHLIGHTS_DETAIL_ERROR,
  DELETE_PATCH_HIGHLIGHTS_DETAIL,
} from 'redux/highlights/types';

const initialState = {
  highlightsDetailsList: null,
  highlightsDetailsListError: null,
  addHighlightsDetailSuccess: null,
  addHighlightsDetailError: null,
  patchHighlightsDetailSuccess: null,
  patchHighlightsDetailError: null,
  deleteHighlightsDetailSuccess: null,
  deleteHighlightsDetailError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HIGHLIGHTS_DETAILS_SUCCESS:
      return {
        ...state,
        highlightsDetailsList: action.payload.data,
        highlightsDetailsListError: null,
      };
    case GET_HIGHLIGHTS_DETAILS_ERROR:
      return {
        ...state,
        highlightsDetailsList: null,
        highlightsDetailsListError: action.payload.data,
      };
    case CLEAR_GET_HIGHLIGHTS_DETAILS:
      return {
        ...state,
        highlightsDetailsList: null,
        highlightsDetailsListError: null,
      };
    case ADD_HIGHLIGHTS_DETAIL_SUCCESS:
      return {
        ...state,
        addHighlightsDetailSuccess: action.payload.data,
        addHighlightsDetailError: null,
      };
    case ADD_HIGHLIGHTS_DETAIL_ERROR:
      return {
        ...state,
        addHighlightsDetailSuccess: null,
        addHighlightsDetailError: action.payload.data,
      };
    case CLEAR_ADD_HIGHLIGHTS_DETAIL:
      return {
        ...state,
        addHighlightsDetailSuccess: null,
        addHighlightsDetailError: null,
      };
    case PATCH_HIGHLIGHTS_DETAIL_SUCCESS:
      return {
        ...state,
        patchHighlightsDetailSuccess: action.payload.data,
        patchHighlightsDetailError: null,
      };
    case PATCH_HIGHLIGHTS_DETAIL_ERROR:
      return {
        ...state,
        patchHighlightsDetailSuccess: null,
        patchHighlightsDetailError: action.payload.data,
      };
    case CLEAR_PATCH_HIGHLIGHTS_DETAIL:
      return {
        ...state,
        patchHighlightsDetailSuccess: null,
        patchHighlightsDetailError: null,
      };
    case DELETE_HIGHLIGHTS_DETAIL_SUCCESS:
      return {
        ...state,
        deleteHighlightsDetailSuccess: action.payload.data,
        deleteHighlightsDetailError: null,
      };
    case DELETE_HIGHLIGHTS_DETAIL_ERROR:
      return {
        ...state,
        deleteHighlightsDetailSuccess: null,
        deleteHighlightsDetailError: action.payload.data,
      };
    case DELETE_PATCH_HIGHLIGHTS_DETAIL:
      return {
        ...state,
        deleteHighlightsDetailSuccess: null,
        deleteHighlightsDetailError: null,
      };
    default:
      return state;
  }
};
